import { render, staticRenderFns } from "./VitaminaC.vue?vue&type=template&id=e1c71696&scoped=true&"
import script from "./VitaminaC.vue?vue&type=script&lang=js&"
export * from "./VitaminaC.vue?vue&type=script&lang=js&"
import style0 from "./VitaminaC.vue?vue&type=style&index=0&id=e1c71696&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c71696",
  null
  
)

export default component.exports